
import React      from 'react';
import CSSModules from 'react-css-modules';

import Button from '../Button';

import style from './style.scss';

class YesNoOptionPanel extends React.Component {

    render() {

        return (
            <div styleName="panel">

                <Button onClick={ this.props.yes }
                        disabled={ this.props.isLoading }
                        styleName="button"
                        theme="success">

                    Yes
                </Button>

                <Button onClick={ this.props.no }
                        disabled={ this.props.isLoading }
                        styleName="button"
                        theme="secondary">

                    No
                </Button>

            </div>
        );
    }
}

export default CSSModules(YesNoOptionPanel, style);


// WEBPACK FOOTER //
// ./components/YesNoOptionPanel/index.js